import { createAsyncThunk } from '@reduxjs/toolkit';
import familyFestApi from '@infrastructure/family-fest-api';
export const getAllAccommodationsAsync = createAsyncThunk('familyFestAccommodation/getAllAccommodations', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getAllAccommodations(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message);
    }
});
export const downloadAccommodationExcelAsync = createAsyncThunk('familyFestAccommodation/downloadExcel', async (eventId, { rejectWithValue }) => {
    try {
        await familyFestApi.downloadFamilyFestAccommodationExcel(eventId);
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const AllotteAccommodationToAttendeeAsync = createAsyncThunk('familyFestAccommodation/allotte-accommodation-to-attendee', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.AllotteAccommodationToAttendee(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message);
    }
});
export const getCarAccommodationEligibleAttendeesAsync = createAsyncThunk('familyFestAccommodation/get-car-accommodation-eligible-attendees', async ({ eventId, request }, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getCarAccommodationEligibleAttendees(eventId, request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message);
    }
});
export const moveToCarAccommodationAsync = createAsyncThunk('familyFestAccommodation/move-to-car-accommodation', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.moveToCarAccommodation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message);
    }
});
